import React, { useState, createContext, useEffect, useRef, useCallback } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { Profile_Info } from "services/Profile";

export const ProfileDetailsContext = createContext();

const ProfileDetailsProvider = ({ children }) => {
  const { getAccessTokenSilently, logout } = useAuth0();
  const [profileDetails, setProfileDetails] = useState({});
  // 初回のみAPI呼び出しを行うためのフラグ（再レンダリングによる重複呼び出しを防止）
  const hasFetchedRef = useRef(false);
  // AbortControllerをuseRefで管理（クリーンアップ時のみ使用）
  const controllerRef = useRef(null);

  // logoutをuseCallbackでメモ化（参照の安定性を確保）
  const handleLogout = useCallback(() => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  }, [logout]);

  useEffect(() => {
    // 既にフェッチ済みの場合はスキップ（冪等性を保証）
    if (hasFetchedRef.current) {
      return;
    }

    controllerRef.current = new AbortController();
    const controller = controllerRef.current;

    const getProfileInfo = async () => {
      try {
        const token = await getAccessTokenSilently();
        if (token) {
          localStorage.setItem("accesstoken", token);
          const prof = await Profile_Info(token, { signal: controller.signal})
          const profileData = prof.data;

          // AbortされていなければstateとlocalStorageを更新
          if (!controller.signal.aborted) {
            setProfileDetails(profileData);
            localStorage.setItem("userinfo", JSON.stringify(profileData));
            hasFetchedRef.current = true;
          }
        }
      } catch (error) {
        // Abortエラーは無視
        if (error.name === 'AbortError') {
          return;
        }
        if (error.status === 403) {
          console.log('403 error in user profile fetch:', error);
          handleLogout();
        } else {
          console.log("error in user profile fetch:", error);
          if(error?.error_description === 'grant request is invalid' || error?.error === 'missing_refresh_token'){
            handleLogout();
          }
        }
      }
    }
    getProfileInfo();

    return () => {
      if (controllerRef.current) {
        controllerRef.current.abort();
      }
    };
  }, [getAccessTokenSilently, handleLogout])

  return (
    <ProfileDetailsContext.Provider value={[profileDetails]}>
      { children }
    </ProfileDetailsContext.Provider>
  )
};

export default ProfileDetailsProvider;